export const fb = {
    id: "MENU_FB",
    icon: "GiTeacher",
    text: "FB",
    child: [
      {
        id: "MENU_FB.GROUPS",
        path: "/fb/groups",
        isPublic: false,
        text: "Groups",
        child: [],
      },
      {
        id: "MENU_FB.USERS",
        path: "/fb/users",
        isPublic: false,
        text: "Users",
        child: [],
      },
    ],
  };
  